// Test IDs for the auth feature: the email + password sheet, the optional
// Google button (only rendered when the server reports that provider), and the
// entry points that open the sheet.
//
// Directive:
//   - Keys are camelCase, values are kebab-case shaped as `<feature>-<element>`
//     (or `<feature>-<element>-<qualifier>` when an element repeats). Examples:
//     'login-submit-button', 'cart-quantity-input', 'product-card-image'.
//   - Reference them in JSX as `data-testid={LOGIN.googleButton}`.
//
// Why kebab-case values: required by the e2e agent's CSS-attribute selector matcher.

export const LOGIN = {
	googleButton: 'login-google-button',
	sheet: 'login-sheet',
	close: 'login-close-button',
	modeSignIn: 'login-mode-signin-button',
	modeRegister: 'login-mode-register-button',
	form: 'login-form',
	nameInput: 'login-name-input',
	emailInput: 'login-email-input',
	passwordInput: 'login-password-input',
	passwordToggle: 'login-password-toggle-button',
	submitButton: 'login-submit-button',
	error: 'login-error',
};

export const LOGOUT = {
	button: 'logout-button',
};

// "Set a password" / "Change password" inside the profile's Settings tab —
// the way a Google-created account gains one (PUT /api/auth/password).
export const PASSWORD = {
	openButton: 'password-open-button',
	sheet: 'password-sheet',
	close: 'password-close-button',
	currentInput: 'password-current-input',
	newInput: 'password-new-input',
	submitButton: 'password-submit-button',
	error: 'password-error',
	success: 'password-success',
};
